import { useContext, useState } from "react";
import Paragraph from "../../../elements/p/Paragraph";
import ButtonAction from "../../../elements/buttons/ButtonAction";
import modalContext from "../../../../dataManager/context/modalContext";
import { deleteProduct } from "../../../../api/products/productsApi";
import { toast } from "react-toastify";

const DeleteProduct = () => {
  //context section
  const { onClose, modalParams } = useContext(modalContext);

  //state variables
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  //some handler
  const handleDelete = async (id) => {
    console.log("suppression en cours");

    //start loading
    setLoading(true);

    const { data, error } = await deleteProduct(id);

    if (error) {
      setError(error);
      return setLoading(false);
    }

    setLoading(false);
    onClose();
    toast.success("Le produit à été supprimé avec succes !", {
      theme: "colored",
    });
  };

  return (
    <div className="w-full">
      <Paragraph>êtes vous sûre de vouloir supprimer ce produit ?</Paragraph>
      <div className="mt-4 flex items-center">
        <ButtonAction
          size="small"
          loading={loading}
          onClick={() => handleDelete(modalParams.productId)}
        >
          Supprimer
        </ButtonAction>
        <ButtonAction size="small" type="secondary" onClick={onClose}>
          Anuler
        </ButtonAction>
      </div>

      <span className="mt-1 font-nunito text-sm text-[#fc3838]">
        {error && error}
      </span>
    </div>
  );
};

export default DeleteProduct;
